import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()

export class CitGlobalConstantService {

  basePath: string;

  baseCitectWebAPI: string;

  baseBerlinWebAPI: string;

  baseBerlinApplicationURL: string;

  getUserInfoForRequestToken: string;

  getLicenseDetailsForSoftwareKeyUrl: string;

  getLicenseDetailsForUsbKey: string;

  getKeySerialNumberFirstPart: string;

  sendAuthCodeviaEmail: string;

  sendEmailForVersionUpgradeORRequestAuthCode: string;

  getSitesForSIteID: string;

  licenseGenearatorURL: string;

  gcsResourcePath: string;

  AVEVALogoURL: string;
  AVEVALogoAltURL: string;


  constructor() {

    this.basePath = environment.enviornmentBasePath;

    this.baseCitectWebAPI = environment.environmentCitectBaseAPIURL;

    this.baseBerlinWebAPI = environment.environmentBerlinBaseAPIURL;

    this.baseBerlinApplicationURL = environment.environmentBaseBerlinApplicationURL;

    this.gcsResourcePath = environment.environmentGCSResourceServerURL;

    this.licenseGenearatorURL = environment.environmentGCSResourceServerURL + this.basePath;

    this.getUserInfoForRequestToken = this.baseBerlinWebAPI + "citectlicensegenerator";

    //this.getLicenseDetailsForSoftwareKeyUrl = this.baseCitectWebAPI + "CitLicenseGeneratorProxy/getLicenseDetailsForSoftwareKey";
    //this.getLicenseDetailsForSoftwareKeyUrl = "https://dev-avevagcs-citectlicensegeneratorms.azurewebsites.net/api/CitLicenseGeneratorProxy/getLicenseDetailsForSoftwareKey";
    this.getLicenseDetailsForUsbKey = this.baseCitectWebAPI + "CitLicenseGeneratorProxy/getLicenseDetailsForUsbKey";
    //this.getLicenseDetailsForUsbKey= "https://dev-avevagcs-citectlicensegeneratorms.azurewebsites.net/api/CitLicenseGeneratorProxy/getLicenseDetailsForUsbKey"

   // this.getKeySerialNumberFirstPart = this.baseCitectWebAPI + "CitLicenseGeneratorProxy/getKeySerialNumberFirstPart";
    //this.getKeySerialNumberFirstPart = "https://dev-avevagcs-citectlicensegeneratorms.azurewebsites.net/api/CitLicenseGeneratorProxy/getKeySerialNumberFirstPart";

    this.sendAuthCodeviaEmail = this.baseCitectWebAPI + "CitLicenseGeneratorProxy/sendAuthCodeviaEmail";
    //this.sendAuthCodeviaEmail = "https://dev-avevagcs-citectlicensegeneratorms.azurewebsites.net/CitLicenseGeneratorProxy/sendAuthCodeviaEmail";

    //this.sendEmailForVersionUpgradeORRequestAuthCode = this.baseCitectWebAPI + "CitLicenseGeneratorProxy/sendEmailForVersionUpgradeORRequestAuthCode";
    //this.sendAuthCodeviaEmail ="https://dev-avevagcs-citectlicensegeneratorms.azurewebsites.net/api/CitLicenseGeneratorProxy/sendEmailForVersionUpgradeORRequestAuthCode";
    //this.getSitesForSIteID = this.baseCitectWebAPI + "CitLicenseGeneratorProxy/getSitesForSIteID";
    //this.getSitesForSIteID = "https://dev-avevagcs-citectlicensegeneratorms.azurewebsites.net/api/CitLicenseGeneratorProxy/getSitesForSIteID";
    this.AVEVALogoURL = environment.environmentAVEVALogoURL;
    this.AVEVALogoAltURL = environment.environmentAVEVALogoAltURL;

  }
}
